import { motion } from "framer-motion";
import BackgroundImage from "../../components/ui/BackgroundImage";
import ArrestDocument from "./components/ArrestDocument";
import bgImg from "./assets/images/bg.png";
import badgeImage from "./assets/images/badge.png";
import atlantisLogo from "./assets/images/ATLANTIS.png";

export default () => {
  return (
    <BackgroundImage
      imageSrc={bgImg}
      className="h-screen flex items-center justify-center overflow-hidden"
    >
      <ArrestDocument
        logo={atlantisLogo}
        title="PROCES VERBAL DE ARESTARE"
        fineAmount={2002141}
        prisonDuration="12 months"
        officerData={{
          name: "John",
          surname: "Doe",
          rank: "Chestor General",
        }}
        detaineeData={{
          name: "Jane",
          surname: "Smith",
          cnp: 1234567890123,
        }}
        badgeImage={badgeImage}
        onSave={(payload) => {
          console.log("SAVE payload", payload);
        }}
      />

      {/**<TimeLeftBadge
        current={1}
        max={50}
        className="!fixed bottom-0 right-[16%]"
      />
      <RemainingHoursBadge
        amount={120000}
        className="!fixed bottom-0 right-[5%]"
        time="12:00"
      /> */}
    </BackgroundImage>
  );
};
